// OWNED BY the calls implementation agent (see ../CallsTab.tsx ownership note).
//
// Full-transcript dialog — a fresh port of the legacy CallsDialogSummary
// (speaker-avatared bubble list over splitTranscription), with inline Hebrew
// strings per the CRM revamp convention.

import {
  List,
  Stack,
  Dialog,
  Avatar,
  ListItem,
  IconButton,
  Typography,
  DialogTitle,
  DialogContent,
  ListItemAvatar,
  ListItemText
} from "@material-ui/core";
import { Close } from "@material-ui/icons";
import { stringAvatar } from "utils/contacts/display";
import type { CallSplitTranscription } from "../../../../../../@types/sharedSchema";

type CallTranscriptDialogProps = {
  open: boolean;
  transcription: CallSplitTranscription[];
  onClose: () => void;
};

export function CallTranscriptDialog({
  open,
  transcription,
  onClose
}: CallTranscriptDialogProps): JSX.Element {
  return (
    <Dialog fullWidth open={open} maxWidth="sm" onClose={onClose}>
      <DialogTitle>
        <Stack direction="row" justifyContent="space-between" alignItems="center">
          <Typography variant="h6">תמלול השיחה</Typography>
          <IconButton onClick={onClose} aria-label="סגירה">
            <Close />
          </IconButton>
        </Stack>
      </DialogTitle>
      <DialogContent>
        <List>
          {transcription.map(({ speaker, sentence }, index) => {
            const { sx: avatarSx, children: avatarText } = stringAvatar(speaker);

            return (
              <ListItem key={index} alignItems="flex-start">
                <ListItemAvatar>
                  <Avatar sx={{ ...avatarSx, color: "white" }}>{avatarText}</Avatar>
                </ListItemAvatar>
                <ListItemText
                  primary={speaker}
                  secondary={sentence}
                  secondaryTypographyProps={{ dir: "auto" }}
                />
              </ListItem>
            );
          })}
        </List>
      </DialogContent>
    </Dialog>
  );
}
